import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=1094d4c6&scoped=true&"
import script from "./js/dashboard-page.js?vue&type=script&lang=js&"
export * from "./js/dashboard-page.js?vue&type=script&lang=js&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=1094d4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094d4c6",
  null
  
)

export default component.exports